import React from 'react';
import s from './ButtonLine.module.scss';

export const ButtonLine = ({ children }) => {
  return <div className={s.buttonLine}>{children}</div>;
};
